/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-dark-search': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.459 0A5.262 5.262 0 0 0 .19 5.257a5.262 5.262 0 0 0 5.268 5.258c1.19 0 2.285-.393 3.165-1.055l4.352 4.378.09.075c.258.175.622.137.864-.106.271-.273.285-.703.03-.96L9.62 8.482a5.231 5.231 0 0 0 1.106-3.224A5.262 5.262 0 0 0 5.459 0zm0 1.127c2.248 0 4.084 1.843 4.084 4.13 0 2.288-1.836 4.131-4.084 4.131-2.249 0-4.084-1.843-4.084-4.13 0-2.288 1.835-4.131 4.084-4.131z" _fill="#fff"/>'
  }
})
